<template>
  <div>
    <vx-card>
      <div class="flex flex-row gap-y-5" >
        <div class="h4 flex" style="align-items: center">
          <div id="print-label">
            <p class="flex" style="align-items: center">{{ $t('개인서명관리') }}</p>
          </div>
        </div>

        <div class="ml-auto">
          <vs-button color="secondary" @click="onClickSave">{{ $t('저장') }}</vs-button>
        </div>
      </div>

      <div class="my-page-body mt-8">
        <div class="my-page-item" :style="isMobile ? {'grid-template-columns': '1fr'} : {}">
          <span >{{ $t('서명 방식') }}</span>
          <div class="gap-5">
            <vs-radio v-model="signUploadType" vs-value="image">{{ $t('서명 이미지 업로드') }}</vs-radio>
            <vs-radio v-model="signUploadType" vs-value="draw">{{ $t('서명 직접그리기') }}</vs-radio>
          </div>
        </div>
        <div v-if="signUploadType === 'image'" class="my-page-item " :style="isMobile ? {'grid-template-columns': '1fr'} : {}">
          <span>{{ $t('서명 이미지 업로드') }}</span>
          <div class="grid gap-2">
            <div style="width: 100%; max-width: 492px; height: 180px">
              <file-uploader v-model="signImage" id="imageSign" type="only-image" />
            </div>
            <div>
              <p class="warning mb-2">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_25958_315609)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2.5026C5.85791 2.5026 2.50004 5.86047 2.50004 10.0026C2.50004 14.1447 5.85791 17.5026 10 17.5026C14.1422 17.5026 17.5 14.1447 17.5 10.0026C17.5 5.86047 14.1422 2.5026 10 2.5026ZM0.833374 10.0026C0.833374 4.93999 4.93743 0.835938 10 0.835938C15.0627 0.835938 19.1667 4.93999 19.1667 10.0026C19.1667 15.0652 15.0627 19.1693 10 19.1693C4.93743 19.1693 0.833374 15.0652 0.833374 10.0026ZM10.2152 6.69001C9.8273 6.62347 9.42834 6.69637 9.089 6.8958C8.74967 7.09523 8.49186 7.40832 8.36125 7.77962C8.20852 8.21377 7.73276 8.44192 7.2986 8.28919C6.86444 8.13647 6.6363 7.6607 6.78903 7.22654C7.05025 6.48395 7.56586 5.85777 8.24453 5.45891C8.9232 5.06005 9.72113 4.91425 10.497 5.04734C11.2729 5.18042 11.9766 5.58379 12.4836 6.18602C12.9904 6.78812 13.2679 7.55015 13.2668 8.33717C13.2664 9.61247 12.3209 10.4547 11.6457 10.9048C11.2827 11.1468 10.9256 11.3248 10.6625 11.4417C10.5298 11.5007 10.4181 11.5454 10.3376 11.5761C10.2972 11.5915 10.2645 11.6034 10.2407 11.6118L10.2118 11.622L10.2026 11.6251L10.1993 11.6262L10.198 11.6266C10.1978 11.6267 10.197 11.627 9.93347 10.8364L10.197 11.627C9.76037 11.7725 9.28844 11.5366 9.1429 11.0999C8.99746 10.6636 9.23301 10.192 9.66908 10.0461L9.68237 10.0415C9.69519 10.0369 9.7162 10.0293 9.74423 10.0186C9.80042 9.9972 9.88398 9.96384 9.98565 9.91865C10.1913 9.82723 10.4592 9.69269 10.7212 9.51804C11.2959 9.13493 11.6001 8.72736 11.6001 8.33641L11.6001 8.33517C11.6007 7.94157 11.462 7.56047 11.2085 7.25935C10.955 6.95824 10.6032 6.75655 10.2152 6.69001ZM10 13.3359C9.5398 13.3359 9.16671 13.709 9.16671 14.1693C9.16671 14.6295 9.5398 15.0026 10 15.0026H10.0084C10.4686 15.0026 10.8417 14.6295 10.8417 14.1693C10.8417 13.709 10.4686 13.3359 10.0084 13.3359H10Z" fill="#3C3C3C"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_25958_315609">
                      <rect width="20" height="20" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>{{ $t('흰 배경(A4용지 등)에 직접 서명하여 찍은 사진을 기기(PC, 태블릿 등)에 저장하여 업로드 합니다.') }}</p>
              <p class="danger">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8.99749C0 4.03068 4.02707 0 9 0C13.9729 0 18 4.03068 18 8.99749C18 13.9643 13.9729 17.995 9 17.995C4.02707 17.995 0 13.9643 0 8.99749ZM9 1.99499C5.13637 1.99499 2 5.12776 2 8.99749C2 12.8672 5.13637 16 9 16C12.8636 16 16 12.8672 16 8.99749C16 5.12776 12.8636 1.99499 9 1.99499Z" fill="#EA5455"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 2.55469C9.62132 2.55469 10.125 3.05696 10.125 3.67656V9.2859C10.125 9.90549 9.62132 10.4078 9 10.4078C8.37868 10.4078 7.875 9.90549 7.875 9.2859V3.67656C7.875 3.05696 8.37868 2.55469 9 2.55469Z" fill="#EA5455"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 11.5313C9.62132 11.5313 10.125 12.0335 10.125 12.6531L10.125 13.775C10.125 14.3946 9.62132 14.8969 9 14.8969C8.37868 14.8969 7.875 14.3946 7.875 13.775L7.875 12.6531C7.875 12.0335 8.37868 11.5313 9 11.5313Z" fill="#EA5455"/>
                </svg>{{ $t('1MB 이하의 이미지형식(JPG, PNG 등) 파일만 업로드 가능합니다)') }}</p>
            </div>
          </div>
        </div>
        <div v-if="signUploadType === 'draw'" class="my-page-item" :style="isMobile ? {'grid-template-columns': '1fr'} : {}">
          <span>{{ $t('서명') }}</span>
          <div>
            <sign-field class="sign-field-draw" ref="imageDraw" v-model="signDraw"/>
          </div>
        </div>

      </div>
    </vx-card>
  </div>
</template>

<script>
import FileUploader from "@/components/FileUploader.vue";
import SignField from "@/components/SignField.vue";

export default {
  name: "MyPageSignUpdate",
  components: {
    SignField,
    FileUploader
  },

  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isMobile() {
      return this.$viewport.isMobile;
    }
  },

  data() {
    return {
      signUploadType: "image",
      signImage: undefined,
      signDraw: undefined,

      signList: [],
    };
  },
  created() {
    this.initBreadcrumb();
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "마이페이지" }, { title: "설정" }, { title: "개인서명관리", active: true }]);
    },
    async file_upload_blob(dataURL) {
      const blobBin = atob(dataURL.split(',')[1]);
      const array = [];
      for(let i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
      }
      const date = new Date().getTime();
      const file = new File([new Uint8Array(array)], `서명_${date}.png`, {type: 'image/png'});

      await this.$store.dispatch("file/FILE_UPLOAD", file);
      return this.$store.state.file.uploadedFile;
    },

    onClickSave () {
      if (this.signUploadType === 'image' && !this.signImage) {
        document.getElementById('imageSign').click();
        return;
      } else if (this.signUploadType === 'draw' && !this.signDraw) {
        this.$refs.imageDraw.handleClickImage();
        return;
      }


      if (this.signUploadType === 'image') {
        this.uploadSign(this.signImage);
      } else if (this.signUploadType === 'draw') {
        this.file_upload_blob(this.signDraw).then((file) => {
          this.uploadSign(file);
        }).catch((error) => {
          const customAlert = new CustomEvent("customAlert", {
            detail: {
              title: "에러",
              message: error,
            },
          });
          window.dispatchEvent(customAlert);
        });
      }
    },

    uploadSign (file) {
      this.$store.dispatch("member/CREATE_SIGNATURE", {
        description: '',
        fileId: file.id,
        makeDefault: true,
        removeAll: true,
      }).then((message) => {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "알림",
            message: message,
          },
        });
        window.dispatchEvent(customAlert);
      }).catch((error) => {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "에러",
            message: error,
          },
        });
        window.dispatchEvent(customAlert);
      });
    },


    loadSign () {
      const options = {
        name: '',
      };
      this.$store.dispatch("member/LOAD_SIGNATURE", options).then((signList) => {
        console.log("signList", signList)
        let defaultSign = undefined;
        for (let i = 0; i < signList.length; i++) {
          if (signList[i].is_default) {
            defaultSign = signList[i];
            break;
          }
        }
        this.signList = signList
      }).catch((error) => {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "에러",
            message: error,
          },
        });
        window.dispatchEvent(customAlert);
      });
    }
  },
};
</script>

<style scoped>
.my-page-body {
  display: grid;
  gap: 1rem;

  & .my-page-item {
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: 10px;

    & > span{
      line-height: 2.5;
      color: #3C3C3C;
      font-size: 16px;
      font-weight: 500;
    }

    & > div{
      display: flex;
      justify-content: left;
      align-content: center;
    }

    p.warning,
    p.danger {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 14px;
      font-weight: 500;
    }
    p.warning { color: #3C3C3C; }
    p.danger { color: #EA5455; }
  }


}
</style>

<style lang="scss">
  .sign-field-draw {
    width: 100%;
    min-height: 180px;
    max-width: 492px;

    & > .sign-field {
      max-width: none;
    }
  }
</style>
